import React, { PureComponent } from 'react';
import { string, func, bool, array, oneOfType } from 'prop-types';
import Dropdown from 'components/Dropdown/Dropdown';
import classnames from 'classnames';
import './SortItem.scss';
import { SortItemButtonDropdown } from './components';

export default class SortItem extends PureComponent {
    static propTypes = {
        label: string.isRequired,
        value: oneOfType([string, array]).isRequired,
        className: string,
        active: bool,
        onClick: func.isRequired,
    };

    static defaultProps = {
        className: null,
        active: false,
    };

    handleClick = evt => {
        const { onClick, value } = this.props;
        if (onClick) {
            onClick(value, evt);
        }
    };

    render() {
        const { active, label, value, className, onClick } = this.props;
        const rootClassnames = classnames(
            'sort-item-root',
            {
                'sort-item-root_active': active,
            },
            className,
        );

        return (
            <React.Fragment>
                {Array.isArray(value) ? (
                    <Dropdown
                        label={label}
                        className={rootClassnames}
                        theme={{ content: 'sort-item-dropdown-container' }}
                    >
                        {value.map(val => (
                            <SortItemButtonDropdown
                                key={val.value}
                                value={val.value}
                                label={val.label}
                                onClick={onClick}
                            />
                        ))}
                    </Dropdown>
                ) : (
                    <button
                        className={rootClassnames}
                        data-sort-value={value}
                        onClick={this.handleClick}
                    >
                        {label}
                    </button>
                )}
            </React.Fragment>
        );
    }
}
